import {Component, Input, OnInit} from "@angular/core";
import {C1Bill, C1BillResult, C1Disposition} from "../../shipper";
import {NgForOf, NgIf} from "@angular/common";

@Component({
	selector: 'bill-result-item',
	standalone: true,
	template: `

        <div >
            <div class="card-block">

                <div *ngIf="result.importingVessel !== null">
                    <table class="table table-sm table-bordered">
                        <thead >
                        <tr>
                            <th>
                                <div>Vessel</div>
                            </th>
                            <th>Voyage/Flight</th>
                            <th>Carrier</th>
                            <th>Arrival</th>
                            <th>Firms Code</th>
                        </tr>
                        </thead>
						<tbody class="">
							<tr>
								<td><strong>{{ result.importingVessel }}</strong></td>
								<td><strong>{{ result.voyageNumber}}</strong></td>
								<td>{{ result.carrierCode}}</td>
								<td>{{ result.arrivalDate}}</td>
								<td>{{ result.firms}}</td>
							</tr>
						</tbody>
                    
                    </table>
                </div>

                <div *ngIf="result.bills.length > 0 && isOcean(result.bills)">
                    <span>Bills</span>
                    <table class="table table-sm table-condensed table-bordered table-striped">
                        <thead class="t-dark">
                        <tr>
                            <th>Master</th>
                            <th>House</th>
                            <th>Bill Type</th>
                            <th>Inbond</th>
                            <th>Unit</th>
                            <th>MOT</th>
                            <th>ISF</th>
                        </tr>
                        </thead>
                        <tr *ngFor="let b of result.bills;">
                            <td>{{ b.masterBillScac + b.masterBillNumber}}</td>
                            <td>{{ b.houseBillScac + b.houseBillNumber}}</td>
                            <td>{{ billType(b.billType)}} <span class="badge badge-secondary">{{b.billType}}</span></td>
                            <td>{{ b.inbondNumber}}</td>
                            <td>{{ b.unit}}</td>
                            <td>{{ b.motCode}}</td>
                            <td>{{ b.isfIndicator}}</td>
                        </tr>
                    </table>
                </div>

                
				<div *ngIf="result.disposition.length > 0 && isOcean(result.bills)">
                    <span>Disposition</span>
                    <table class="table table-sm table-condensed table-bordered table-striped">
                        <thead class="t-dark">
                        <tr>
                            <th>Sequence</th>
                            <th>Code</th>
                            <th>Qnty</th>
                            <th>Datetime</th>
                            <th>Message</th>
                        </tr>
                        </thead>
                        <tr *ngFor="let d of result.disposition;">
                            <td>{{ d.sequence}}</td>
                            <td>{{ d.actionCode}}</td>
                            <td>{{ d.quantity}}</td>
                            <td>{{ d.actionDate + " " + d.actionTime}}</td>
                            <td>{{ d.message}}</td>
                        </tr>
                    </table>
                </div>
				

                <div *ngIf="result.ports.length > 0">
                    <span>Ports</span>
                    <table class="table table-sm table-condensed table-bordered table-striped">
                        <thead class="t-dark">
                        <tr>
                            <th title="Manifested and/or Actual">Port of Unlading</th>
                            <th>Vessel Departure</th>
                            <th>Inbond No</th>
                            <th>Manifested Inbond Dest.</th>
                            <th>Inbond Dest. Diversion</th>
                            <th>Inbond Orig. Port</th>
                            <th>Import Ocean Diversion</th>
                        </tr>
                        </thead>
                        <tr *ngFor="let p of result.ports;">
                            <td>
                                <span *ngIf="p.actualPortOfUnlading != null" class="badge badge-primary">Actual: {{p.actualPortOfUnlading}}</span>
                                <span *ngIf="p.manifestedPortOfUnlading != null" class="badge badge-default">Manifested: {{p.manifestedPortOfUnlading}}</span>
                            </td>
                            <td>
                                <div *ngIf="p.vesselDeparturePort !=null ">
                                    <strong>Date:</strong> {{p.vesselDepartureDate}} <strong>Port:</strong> {{p.vesselDeparturePort}}
                                </div>
                            </td>
                            <td>{{p.inbondEntryNumber}}</td>
                            <td>{{p.manifestedInbondDestinationPort}}</td>
                            <td>
                                <div *ngIf="p.inbondDestinationManualDiversion != null" class="badge badge-primary">
                                    Manual: {{p.inbondDestinationManualDiversion}}
                                </div>

                                <div *ngIf="p.inbondDestinationEdiDiversion != null" class="badge badge-default">
                                    EDI: {{p.inbondDestinationEdiDiversion}}
                                </div>
                            </td>
                            <td>{{p.inbondOriginatingPort}}</td>
                            <td>{{p.importOceanVesselDiversion}}</td>
                        </tr>
                    </table>
                </div>
				

                <div *ngIf="result.bills.length > 0 && isAir(result.bills)">
                    <span>Airbill</span>
                    <table class="table table-sm table-condensed table-bordered table-striped">

                        <thead class="t-dark">
                        <tr>
                            <th>Split</th>
                            <th>Master bill</th>
                            <th>Manifested | Boarded Qnty</th>
                            <th>House Waybill</th>
                            <th>H Split</th>
                            <th>H Manifested | Boarded Qnty</th>
                            <th>Inbond No</th>
                            <th>Inbond Status</th>
                            <th>Carrier</th>
                            <th>Flight No</th>
                            <th>Datetime</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let d of result.bills;">
                            <td>
                           <span *ngIf="d.masterAirbillPartIndicator != null" class="badge badge-default split-{{d.masterAirbillPartIndicator}}">
                              {{ d.masterAirbillPartIndicator}}
                           </span>
                            </td>
                            <td>
                                {{ d.airbillNumber}}
                            </td>
                            <td>
                                {{d.masterAirbillManifestQuantity}}
                                <span *ngIf="d.masterAirbillManifestQuantity != null">| {{d.masterAirbillManifestQuantity}}</span>
                            </td>
                            <td>
                            <span *ngIf="d.houseAirbillNumber != null" class="badge badge-info">
                                {{ d.houseAirbillNumber}}
                            </span>
                            </td>
                            <td>{{ d.houseAirbillPartIndicator}}</td>
                            <td>
                        <span *ngIf="d.houseAirbillManifestQuantity != null">
                            {{d.houseAirbillManifestQuantity}}
                            <span *ngIf="d.houseAirbillPartIndicator != null">| {{d.houseAirbillBoardedQuantity}}</span>
                        </span>
                            </td>
                            <td>
                                <span *ngIf="d.inbondNumber != null" class="badge badge-warning">{{ d.inbondNumber}}</span>
                            </td>
                            <td>{{ d.inbondStatus}}</td>
                            <td>{{ d.carrierCode}}</td>
                            <td>{{ d.flightNumber}}</td>
                            <td>{{ d.scheduledArrivalDate}}</td>
                        </tr>
                        </tbody>

                    </table>
                </div>


                <div *ngIf="result.bills.length > 0 && isAir(result.bills)">
                    <span>Disposition</span>
                    <table class="table table-sm table-condensed table-bordered table-striped">
                        <thead class="t-dark">
                        <tr>
                            <th>Code</th>
                            <th>Message</th>
                            <th>Datetime</th>
                        </tr>
                        </thead>
                        <tr *ngFor="let d of dsort(result.disposition);">
                            <td>{{d.actionCode}}</td>
                            <td>{{d.message}}</td>
                            <td>{{d.actionDate + " " + d.actionTime}}</td>
                        </tr>
                    </table>
                </div>


            </div>
        </div>
	
	`,
	imports: [
		NgIf,
		NgForOf
	],
	styleUrls: [`c1.css`],
})
export class C1BillResultItem implements OnInit{
	
	@Input()
	result!:C1BillResult;
	
	@Input()
	isCollapsed = false;
	
	private billTypes:Map<string,string> = new Map([
		["0","Regular"],
		["M","Master"],
		["H","House"],
		["F","FROB"]
	]);
	
	
	ngOnInit(): void {
		this.result.disposition = this.dsort(this.result.disposition);
	}
	
	
	/**
	 *
	 * @param bills
	 */
	public isAir(bills:Array<C1Bill>):boolean{
		return bills[0].billType == null;
	}
	
	
	/**
	 *
	 * @param bills
	 */
	public isOcean(bills:Array<C1Bill>){
		return bills[0].billType != null;
	}
	
	
	/**
	 *
	 * @param type
	 */
	public billType(type:string|undefined){
		
		if(!type){return null;}
		
		if(this.billTypes.has(type)){
			return this.billTypes.get(type);
		}
		
		return type;
	}
	
	
	/**
	 *
	 * @param disposition
	 */
	public dsort(disposition:Array<C1Disposition>){
		
		return disposition.sort((a,b) => {
			if(Number(a.sequence) > Number(b.sequence)){return 1;}
			if(Number(a.sequence) < Number(b.sequence)){return -1;}
			return 0;
		});
		
	}
}
